<template>
  <div v-if="apn_info" class="apn_info">
    <div class="apn_info__left">
      <div class="line row">
        <div class="col-md-3 col-sm-3">
          <fg-input :value="apn_info.apn" type="text" :label="translate('apn_list.apn')"
                    :placeholder="translate('apn_list.apn')" :readonly="true" />
        </div>
        <div class="col-md-3 col-sm-3">
          <fg-input :value="apn_info.mno_name" type="text" :label="translate('apn_list.mno_name')"
                    :placeholder="translate('apn_list.mno_name')" :readonly="true" />
        </div>
        <div class="col-md-3 col-sm-3">
          <fg-input :value="apn_info.device_count" type="text" :label="translate('apn_list.device_count')"
                    :placeholder="translate('apn_list.device_count')" :readonly="true" />
        </div>
        <div class="col-md-3 col-sm-3">
          <fg-input :value="apn_info.network_access_type" type="text" :label="translate('apn_list.network_access_type')"
                    :placeholder="translate('apn_list.network_access_type')" :readonly="true" />
        </div>
      </div>

      <div class="line row">
        <div class="col-md-3 col-sm-3">
          <fg-input :value="apn_info.device_apn_mode" type="text" :label="translate('apn_list.device_apn_mode')"
                    :placeholder="translate('apn_list.device_apn_mode')" :readonly="true" />
        </div>
        <div class="col-md-3 col-sm-3">
          <fg-input :value="apn_info.provisioning_mode" type="text" :label="translate('apn_list.provisioning_mode')"
                    :placeholder="translate('apn_list.provisioning_mode')" :readonly="true" />
        </div>
        <div class="col-md-3 col-sm-3">
          <fg-input :value="apn_info.ip_networks" type="text" :label="translate('apn_list.ip_networks')"
                    :placeholder="translate('apn_list.ip_networks')" :readonly="true" />
        </div>
        <div class="col-md-3 col-sm-3">
          <fg-input :value="date_create" type="text" :label="translate('apn_list.ts_create')"
                    :placeholder="translate('apn_list.ts_create')" :readonly="true" />
        </div>
      </div>

      <div class="line row">
        <div class="col-md-3 col-sm-3 form-group">
          <label>{{ translate('apn_list.client_names') }}</label>
          <tree-select :value="client_ids" :options="client_list" :multiple="true" :disabled="true"
                       :placeholder="translate('apn_list.client_names')" />
        </div>
        <div class="col-md-3 col-sm-3 form-group">
          <label>{{ translate('apn_list.oper_account') }}</label>
          <tree-select :value="oper_account_ids" :options="oper_account_list" :multiple="true" :disabled="true"
                       :placeholder="translate('apn_list.oper_account')" />
        </div>
        <div class="col-md-3 col-sm-3">
          <div class="filter checkbox">
            <div class="info">{{ translate('apn_list.is_active') }}</div>
            <label class="switch no-user-access">
              <input type="checkbox" :checked="Number(apn_info.is_active) === 1" disabled>
              <span class="slider round"></span>
            </label>
          </div>
        </div>
      </div>

      <div class="line row">
        <div class="col-md-6 col-sm-6 text_wrap">
          <div class="form-group">
            <label>{{ translate('apn_list.params') }}</label>
            <textarea class="input_text" rows="12" :value="params" readonly />
          </div>
        </div>
        <div class="col-md-6 col-sm-6 text_wrap">
          <div class="form-group">
            <label>{{ translate('apn_list.comment') }}</label>
            <textarea class="input_text" rows="12" :value="apn_info.comment" readonly />
          </div>
        </div>
      </div>
    </div>

    <div class="apn_info__right">
      <Summary
        type="apn"
        :info="apn_info"
        :view_history="false"
      />
    </div>
  </div>
</template>

<script>
import Summary from "components/UIComponents/Summary/Summary.vue";

export default {
  name: 'ApnInfo',
  components: {
    Summary
  },
  props: {
    apn: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      apn_info: {}
    }
  },
  created() {
    this.apn_info = JSON.parse(JSON.stringify(this.apn))
  },
  activated() {
    this.apn_info = JSON.parse(JSON.stringify(this.apn))
  },
  computed: {
    client_list(){
      return (this.apn.client_names || []).map((client, index) => {
        return {label: client, id: index}
      })
    },
    client_ids(){
      return this.client_list.map((client) => client.id)
    },
    oper_account_list(){
      return (this.apn.oper_accounts || []).map((account, index) => {
        return {label: account.oper_account, id: index}
      })
    },
    oper_account_ids(){
      return this.oper_account_list.map((account) => account.id)
    },
    date_create() {
      return this.get_date(this.apn.ts_create)
    },
    params() {
      let params = this.apn.params
      return params == null ? '' : typeof params === 'string' ? params : JSON.stringify(params, null, 2)
    }
  },
  watch: {
    apn(){
      this.apn_info = JSON.parse(JSON.stringify(this.apn))
    }
  }
}
</script>

<style lang='scss' scoped>
.apn_info {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  overflow: auto;

  @media (max-width: 991px) {
    flex-direction: column;
  }

  &__left {
    width: 70%;
    height: 100%;
    padding-right: 10px;
    .form-group {
      margin-bottom: 10px;
    }
    @media (max-width: 991px) {
      width: 100%;
      height: auto;
    }
  }

  &__right {
    width: 30%;
    height: 100%;
    @media (max-width: 991px) {
      width: 100%;
      height: auto;
    }
  }
}
</style>
